import { ListPickerControlConfig } from "./list-picker-control-config.model";
import { Control } from "../../business-objects/control/control.model";

export class ListPickerControl extends Control {
    config: ListPickerControlConfig;
}



// WEBPACK FOOTER //
// ./src/vas/controls/list-picker/list-picker-control.model.ts